import './CheckBox.scss'

function CheckBox({ error, touched, name, onChange, checked }) {
	function openPdfInNewWindow() {
		window.open('Personal_data_processing_policy_SL_Cosmos.pdf', '_blank')
	}

	return (
		<div className="checkbox">
			<div className="checkbox__wrapper">
				<div className="checkbox-input__wrapper">
					<input
						type="checkbox"
						className="checkbox-input"
						id={name}
						name={name}
						onChange={onChange}
						checked={checked}
					/>

					<label htmlFor={name}></label>
				</div>

				<label htmlFor={name} className="checkbox-label">
					Даю согласие на <span className="checkbox-agreement" onClick={openPdfInNewWindow}>
						обработку персональных данных
					</span>
				</label>
			</div>

			{
				error && touched &&
					<p className="checkbox-error">
						{ error }
					</p>
			}
		</div>
	)
}

export default CheckBox